module.exports = "https://static.wmbcdn.com/uniweb/images/a430eb9b9ecc761c3d46df50b80f2031.svg";